export const calcPercent = (percent: number, total: number) => {
  return ((percent * total) / 100).toFixed(2);
};

export const toPercentageDecimal = (partialValue: number, totalValue: number) => {
  return parseFloat(((100 * partialValue) / totalValue).toFixed(2));
};

export const percentOf = (numA: any, numB: any) => {
  return (numA / numB) * 100;
};
